/**
 * PDP rows (snippets/nw-pdp-row.liquid)
 * - nw-panel: the panels for How To Measure, How To Install, Shipping & Returns …
 *   Built on the theme's x-drawer (theme.js), so focus trap, Esc/overlay close and scroll lock come from the theme.
 *   Desktop (700px+): drawer from the right. Mobile: bottom sheet, using the theme modal's slide-up animation.
 *   Opens from any button with aria-controls="<panel id>".
 * - "Show Less" at the end of an open row's text closes the row.
 * - Panels with several pages (e.g. How To Install: Wallpaper / Peel & Stick): the select shows one at a time.
 */
customElements.whenDefined('x-drawer').then(() => {
  if (customElements.get('nw-panel')) return;

  const Drawer = customElements.get('x-drawer');
  const Modal = customElements.get('x-modal');
  const sheetQuery = window.matchMedia('(max-width: 699px)');

  class NwPanel extends Drawer {
    // Inside the configurator modal (a <dialog> on top of everything) the panel must stay in it,
    // or it would open behind the modal (configurator-web moves it in and back)
    get shouldAppendToBody() {
      return !this.closest('dialog');
    }
    createEnterAnimationControls() {
      return sheetQuery.matches
        ? Modal.prototype.createEnterAnimationControls.call(this)
        : super.createEnterAnimationControls();
    }

    createLeaveAnimationControls() {
      return sheetQuery.matches
        ? Modal.prototype.createLeaveAnimationControls.call(this)
        : super.createLeaveAnimationControls();
    }
  }

  customElements.define('nw-panel', NwPanel);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-nw-show-less]');
  if (!button) return;

  button.closest('accordion-disclosure')?.close();
});


document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-nw-panel-select]');
  if (!select) return;

  const panel = select.closest('nw-panel');

  panel.querySelectorAll('[data-nw-panel-page]').forEach((page) => {
    page.hidden = page.dataset.nwPanelPage !== select.value;
  });

  // Start the new guide from the top
  panel.shadowRoot?.querySelector('[part="body"]')?.scrollTo({ top: 0 });
});